import { CHILD_MIN_WIDTH } from "../../../../excelPreview.constants"

export const getStyles = ({ childrenLength, index }) => ({
    containerRowCellS: {
        borderLeft: index > 0 && '1px solid #e0e0e0',
        minWidth: `${childrenLength * CHILD_MIN_WIDTH}px`,
        width: '100%'
    },
})
